@use '@/flavours/glitch/styles/mastodon/mixins';
@use '@/flavours/glitch/styles/mastodon/variables';
@use './navigation_link.module.scss' as navigation-link;

.root {
  padding-top: var(--space-4);

  :any-link {
    color: inherit;

    &:hover,
    &:focus-visible {
      text-decoration: none;
    }
  }
}

.title {
  @include navigation-link.link-base;

  min-height: 32px;
  padding: var(--space-1) var(--space-2);
  margin-bottom: var(--space-half);

  @include mixins.type-meta;

  color: var(--color-text-secondary);

  @media (width < variables.$mobile-menu-breakpoint) {
    min-height: 40px;
  }
}

.toggleIcon {
  width: 20px;
  height: 20px;
  margin-inline-start: auto;
  transition: rotate 100ms ease-in;

  .title[aria-expanded='true'] & {
    rotate: -180deg;
  }
}

.emptyState {
  @include mixins.type-caption;

  padding-inline: var(--space-2);
}
